import { render, staticRenderFns } from "./DigitSpanForward.vue?vue&type=template&id=59bad1c3&scoped=true&"
import script from "./DigitSpanForward.vue?vue&type=script&lang=js&"
export * from "./DigitSpanForward.vue?vue&type=script&lang=js&"
import style0 from "./DigitSpanForward.vue?vue&type=style&index=0&id=59bad1c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bad1c3",
  null
  
)

export default component.exports